import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AlertService } from '../../../_services/alert.service';
import { v4 as uuidv4 } from 'uuid';
import * as firebase from 'firebase';
import * as _ from 'underscore';
import * as moment from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: '',
  templateUrl: './flight-activity.component.html',
  styleUrls: ['./flight-activity.component.css']
})
export class FlightActivityComponent implements OnInit {

  currOrganization: any;
  loggedInUser: any;
  modalRef: any;
  d1: any;
  d2: any;
  iconTab: FormGroup;
  meals = ['Yes', 'No'];
  members = ['Walter White', 'Jessy Pinkman', 'Heisenberg', 'Skylar White', 'Saul Goodman']
  modes = ['Bus', 'Train']
  mealTypes = ['Personal', 'Client', 'Team']
  mealSession = ['Breakfast', 'Lunch', 'Dinner', 'Others']

  private activityList: Array<any> = [];
  tagList = [];
  isLoading: any = false;
  selectedItems = [];
  diffList = [];
  dropdownSettings = {};
  keyIndex: any = -1;
  minDate: any;
  maxDate: any;
  currMinDate: any;
  currMaxDate: any;
  isUploading: any = false;
  snapList: any = [];
  flightStart: any;
  flightEnd: any;
  meetingStartDate: any;
  startDate: any;
  flightEndDate: any;
  editData: any;
  addedBy: any;
  verifyFields = [
    {
      "key": "prefAirline",
      "value": "Preferred-Airline"
    },
    {
      "key": "meetingStartDate",
      "value": "FlightStartDate",
      "isDate": true
    },
    {
      "key": "meetingEndDate",
      "value": "FlightEndDate",
      "isDate": true
    },
    {
      "key": "flightStartTime",
      "value": "FlightStartTime"
    },
    {
      "key": "flightEndTime",
      "value": "FlightEndTime"
    },
    {
      "key": "prefAirDeparture",
      "value": "PrefAirDeparture"
    },
    {
      "key": "prefTimeArrival",
      "value": "PrefTimeOfArrival"
    },
    {
      "key": "prefAirArrival",
      "value": "PrefAirForArrival"
    },
    {
      "key": "meals",
      "value": "Meals"
    },
    {
      "key": "luggage",
      "value": "Luggage"
    },
    {
      "key": "tagMembersMeet",
      "value": "TagMembers"
    },
    {
      "key": "otherInfo",
      "value": "OtherInfo"
    },
    {
      "key": "transNumber",
      "value": "Transaction-Number"
    },
    {
      "key": "merchName",
      "value": "MerchantName"
    },
    {
      "key": "travelClass",
      "value": "TravelClass"
    }
  ]

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
    }
    if (window.localStorage.getItem('currOrganization')) {
      this.currOrganization = JSON.parse(window.localStorage.getItem('currOrganization'));
    }

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };

  }

  @Input() data: any;
  @Input() travellers: any;
  @Input() createdBy: any;
  @Input() code: any;
  @Input() isReadOnly: any;
  @Input() isDisabled: any;
  @Input() isActivityEdit: any;
  @Output() flightData: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    // this.amendment()
    this.iconTab = this.formBuilder.group({
      activityDetails: [[]],
      // Flight Activity
      category: ['', Validators.required],
      // flightStartDate: ['', Validators.required],
      meetingStartDate: ['', Validators.required],
      meetingEndDate: ['', Validators.required],
      // flightEndDate: ['', Validators.required],
      meetingStart: ['', Validators.required],
      meetingEnd: ['', Validators.required],
      flightStartTime: ['', Validators.required],
      flightEndTime: ['', Validators.required],
      prefAirline: ['', Validators.required],
      prefTimeArrival: ['', Validators.required],
      prefAirDeparture: ['', Validators.required],
      prefAirArrival: ['', Validators.required],
      meals: ['', Validators.required],
      luggage: ['', Validators.required],
      tagMembersMeet: ['', Validators.required],
      otherInfo: ['', Validators.required],
      transNumber: ['', Validators.required],
      merchName: ['', Validators.required],
      travelClass: ['', Validators.required],
      createdBy: ['', Validators.required],
      addedBy: ['', Validators.required],
    });

    this.tagList = this.travellers;
    // this.selectedItems = this.tagList;
    console.log(this.tagList)
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.iconTab.patchValue(this.data);
    this.addedBy = this.data ? this.data.createdBy : this.createdBy;
    this.createdBy = this.data ? this.data.createdBy : this.createdBy + " - " + this.code;
    this.snapList = this.data ? this.data.snapList : '' || [];
    this.selectedItems = this.data ? this.data.tagMembersMeet : '' || [];
    this.diffList = this.data && this.data.activityDiffList || [];
    console.log('data@@', this.data, 'diffList 🎇🎇', this.diffList, this.isReadOnly, this.createdBy, this.code)
  }

  get f() {
    return this.iconTab.controls;
  }

  getDiffItem(key: any, val: any) {
    let d = _.groupBy(this.diffList, 'key')[key]
    if (d && d.length) {
      return d[0][val]
    }
  }

  displayMembers(allMembers: any) {
    allMembers = allMembers.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ',  ');
    return allMembers;
  }

  // flight activity
  flightActivity() {
    this.activityList.push({
      category: "Flight",
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      meetingStart: this.iconTab.value.flightStart,
      meetingEnd: this.iconTab.value.flightEnd,
      flightStartTime: this.iconTab.value.flightStartTime,
      flightEndTime: this.iconTab.value.flightEndTime,
      prefAirline: this.iconTab.value.prefAirline,
      prefTimeArrival: this.iconTab.value.prefTimeArrival,
      prefAirDeparture: this.iconTab.value.prefAirDeparture,
      prefAirArrival: this.iconTab.value.prefAirArrival,
      meals: this.iconTab.value.meals,
      luggage: this.iconTab.value.luggage,
      tagMembersMeet: this.iconTab.value.tagMembers || '',
      otherInfo: this.iconTab.value.otherInfo,
      transNumber: this.iconTab.value.transNumber || '',
      merchName: this.iconTab.value.merchName,
      travelClass: this.iconTab.value.travelClass,
    })
    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: '',
      meetingStartDate: '',
      meetingEndDate: '',
      meetingStart: '',
      meetingEnd: '',
      flightStartTime: '',
      flightEndTime: '',
      prefAirline: '',
      prefTimeArrival: '',
      prefAirDeparture: '',
      prefAirArrival: '',
      meals: '',
      luggage: '',
      tagMembersMeet: '',
      otherInfo: '',
      transNumber: '',
      merchName: '',
      travelClass: '',
    });
    console.log(this.activityList)
  }


  editFlightActivity(index, content) {
    console.log("edit value", this.activityList[index]);

    this.modalRef = this.modalService.open(content, { windowClass: 'animated fadeInDown', size: 'xl' });
    this.keyIndex = index;
    this.iconTab.patchValue({
      meetingStart: this.activityList[index].flightStart,
      meetingEnd: this.activityList[index].flightEnd,
      meetingStartDate: this.activityList[index].meetingStartDate,
      meetingEndDate: this.activityList[index].meetingEndDate,
      flightStartTime: this.activityList[index].flightStartTime,
      flightEndTime: this.activityList[index].flightEndTime,
      prefAirline: this.activityList[index].prefAirline,
      prefTimeArrival: this.activityList[index].prefTimeArrival,
      prefAirDeparture: this.activityList[index].prefAirDeparture,
      prefAirArrival: this.activityList[index].prefAirArrival,
      meals: this.activityList[index].meals,
      luggage: this.activityList[index].luggage,
      tagMembersMeet: this.activityList[index].tagMembers,
      otherInfo: this.activityList[index].otherInfo,
      transNumber: this.activityList[index].transNumber,
      merchName: this.activityList[index].merchName,
      travelClass: this.activityList[index].travelClass,
    });
    this.selectedItems = this.activityList[index].tagMembers
  }

  upDateFlightActivity() {
    this.activityList[this.keyIndex] = {
      category: 'Flight',
      meetingStart: this.iconTab.value.flightStart,
      meetingEnd: this.iconTab.value.flightEnd,
      meetingStartDate: this.iconTab.value.meetingStartDate,
      meetingEndDate: this.iconTab.value.meetingEndDate,
      flightStartTime: this.iconTab.value.flightStartTime,
      flightEndTime: this.iconTab.value.flightEndTime,
      prefAirline: this.iconTab.value.prefAirline,
      prefTimeArrival: this.iconTab.value.prefTimeArrival,
      prefAirDeparture: this.iconTab.value.prefAirDeparture,
      prefAirArrival: this.iconTab.value.prefAirArrival,
      meals: this.iconTab.value.meals,
      luggage: this.iconTab.value.luggage,
      tagMembersMeet: this.iconTab.value.tagMembers,
      otherInfo: this.iconTab.value.otherInfo,
      transNumber: this.iconTab.value.transNumber,
      merchName: this.iconTab.value.merchName,
      travelClass: this.iconTab.value.travelClass,
    };

    this.iconTab.patchValue({
      activityDetails: this.activityList,
      category: 'Flight',
      meetingStart: '',
      meetingEnd: '',
      meetingStartDate: '',
      meetingEndDate: '',
      flightStartTime: '',
      flightEndTime: '',
      prefAirline: '',
      prefTimeArrival: '',
      prefAirDeparture: '',
      prefAirArrival: '',
      meals: '',
      luggage: '',
      tagMembersMeet: '',
      otherInfo: '',
      transNumber: '',
      merchName: '',
      travelClass: '',
    });
    this.keyIndex = -1;
  }


  deleteActivity(index) {
    this.activityList.splice(index, 1);
  }

  selectFlightStartDate(event) {
    console.log(event);
    this.startDate = event;
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;
    console.log(day)
    let finalDate = day + "-" + month + "-" + year;
    console.log(finalDate)
    this.iconTab.patchValue({
      meetingStartDate: finalDate
    })
    this["meetingStart"] = finalDate;
    console.log(this.flightStart)
  }

  selectFlightEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? '0' + event.month : event.month;;
    let day = event.day <= 9 ? '0' + event.day : event.day;
    console.log(day)
    let finalDate = day + "-" + month + "-" + year;
    this.iconTab.patchValue({
      meetingEndDate: finalDate
    })
    this["meetingEnd"] = finalDate;
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  getMinDate() {
    if (this.startDate) {
      return (this.startDate)
    } else {
      return this.minDate
    }
  }

  addNewItem() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Save?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!this.iconTab.value.meetingStart || !this.iconTab.value.flightStartTime || this.iconTab.value.tagMembersMeet.length == 0) {
          this.alertService.showError('Mandatory fields to be filled !');
          return false;
        }

        let isMatch = _.isMatch(this.data, this.iconTab.value);
        if (isMatch && this.isActivityEdit) {
          this.alertService.showError('No Changes made to amend !', 3000, 'Invalid update !')
          return false;
        }

        let activityDiffList = [];
        if (!isMatch && this.isActivityEdit) {
          let that = this;
          let old = _.clone(this.data), fresh = _.clone(this.iconTab.value);
          _.each(this.verifyFields, function(field) {
            let newVal = fresh[field.key], oldVal = old[field.key];
            if (old[field.key] != fresh[field.key]) {
              activityDiffList.push({
                key: field.key,
                name: field.value,
                oldVal: field.isDate ? that.readableDateFormat(old[field.key]) : oldVal,
                newVal: field.isDate ? that.readableDateFormat(fresh[field.key]) : newVal
              })
            }
          })
        }

        console.log('diffList----🎄🎄', activityDiffList, 'am in addNewItem ', this.activityList, this.iconTab.value);
        console.log('key:', this.code);
        this.flightData.emit({ ...this.iconTab.value, activityDiffList: activityDiffList, snapList: this.snapList, key: this.code, category: 'Flight', uniqueId: uuidv4(), addedBy: this.addedBy });
        this.closeModal();
      }
    })
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  chooseFile() {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Upload Confirmation Doc?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        document.getElementById("avatar").click();
      }
    })
  }

  upload() {
    // Create a root reference
    let storageRef = firebase.storage().ref();
    this.isUploading = true;
    let that = this;

    for (let selectedFile of [(<HTMLInputElement>document.getElementById('avatar')).files[0]]) {
      // let path = '/BILLS/' + Date.now() + `${selectedFile.name}`;
      let path = '/BILLS/' + Date.now() + '_' + `${selectedFile.name}`;
      let iRef = storageRef.child(path);
      iRef.put(selectedFile).then((snapshot) => {
        snapshot.ref.getDownloadURL()
          .then((url) => {
            let images = that.snapList || [];
            images.push(url);
            console.log(images)
            that.snapList = images;
            console.log(this.snapList);
            this.isUploading = false;
          })
      });
    }
  }

  removeImage(index: any) {
    // RG
    Swal.fire({
      title: 'Are you sure, You want to Remove?',
      showCancelButton: true,
      confirmButtonText: `OK`,
      // confirmButtonColor: `red`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.snapList.splice(index, 1);
        console.log(this.snapList)
      }
    })
  }

  getFileName(url: any) {
    let data = '';
    if (url.split('_')[1]) {
      data = url.split('_')[1].split('?');
      data = data[0] ? decodeURI(data[0]) : '';
      return data;
    } else {
      return data;
    }
  }

}
